import { render, staticRenderFns } from "./ConfiguracoesIndex.vue?vue&type=template&id=925669d2"
import script from "./ConfiguracoesIndex.vue?vue&type=script&lang=js"
export * from "./ConfiguracoesIndex.vue?vue&type=script&lang=js"
import style0 from "./ConfiguracoesIndex.vue?vue&type=style&index=0&id=925669d2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports